import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class EmpresaConfigService {
  private apiUrl = environment.apiUrl;
  private empresaUrl = `${this.apiUrl}sistema/empresas`;
  private logsUrl = `${this.apiUrl}sistema/logs`;

  constructor(private _http: HttpClient) {
  }

  getEmpresas(): Observable<any[]> {
    return this._http.get(this.empresaUrl)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getEmpresasAcessos(dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.logsUrl}/empresas/${dataInicial}/${dataFinal}/${meses}/${anos}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getUsuariosEmpresaAcessos(empresaId, dataInicial, dataFinal, meses, anos): Observable<any[]> {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    return this._http.get(`${this.logsUrl}/usuarios/${empresaId}/${dataInicial}/${dataFinal}/${meses}/${anos}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getEmpresasAcessoPorPagina(paginas, dataInicial, dataFinal, meses, anos) {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    paginas = JSON.stringify(paginas);
    return this._http.get(`${this.logsUrl}/paginaEmpresas/${paginas}/${dataInicial}/${dataFinal}/${meses}/${anos}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getUsuariosAcessoPorPagina(empresaId, paginas, dataInicial, dataFinal, meses, anos) {
    meses = JSON.stringify(meses);
    anos = JSON.stringify(anos);
    paginas = JSON.stringify(paginas);
    return this._http.get(`${this.logsUrl}/usuariosPaginas/${empresaId}/${paginas}/${dataInicial}/${dataFinal}/${meses}/${anos}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getEmpresa(id: string): Observable<{}> {
    return this._http.get(this.empresaUrl + '/' + id)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertEmpresa(empresa): Observable<{}> {
    return this._http.post(this.empresaUrl, empresa)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  deleteEmpresa(id: string): Observable<boolean> {
    return this._http.delete(this.empresaUrl + '/' + id)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    console.log(error);
    return observableThrowError(error.error || 'Server error');
  }
}
